import React from 'react';

export type SelectedAddress = {
  street: string;
  city: string;
  state: string;
  zipCode: string;
  country?: string;
};

type Props = {
  value: string;
  onChange: (value: string) => void;
  onSelect?: (addr: SelectedAddress) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
};

/**
 * Minimal AddressAutocomplete implementation.
 *
 * Today this is intentionally just a plain input so the app can run without
 * external autocomplete dependencies. The `onSelect` hook is retained so we can
 * later upgrade it (e.g., Google Places) without refactoring callers.
 */
export default function AddressAutocomplete({
  value,
  onChange,
  onSelect: _onSelect,
  placeholder,
  className,
  disabled,
  required,
}: Props) {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || 'Street address'}
      disabled={disabled}
      required={required}
      className={className || 'input w-full'}
      autoComplete="street-address"
    />
  );
}
